module.exports = __webpack_public_path__ + "static/media/Tom.77feb39b.png";